export enum EstateTaskEditorTemplateDocumentStatus {
  AVAILABLE = 'available',
  EDITING_IN_PROGRESS = 'editing_in_progress',
  SENT_FOR_APPROVAL = 'sent_for_approval',
  APPROVED = 'approved',
  CHANGES_REQUESTED = 'changes_requested',
  REJECTED = 'rejected',
  SENT_FOR_REVIEW = 'sent_for_review',
  APPROVED_AUTOMATED = 'approved_automated'
}
